import { useMemo } from 'react';
import { useNetwork } from 'wagmi';

export const useChainId = () => {
  const { chain } = useNetwork();
  return useMemo(() => chain?.id, [chain]);
};
